/**
 * `cn` — concaténation conditionnelle de classes (mini-clsx sans dépendance).
 * Accepte chaînes, faux-y (ignorés) et maps `{classe: bool}`.
 */
export type ClassValue = string | number | false | null | undefined | Record<string, boolean>;

export function cn(...values: ClassValue[]): string {
  const out: string[] = [];
  for (const v of values) {
    if (!v) continue;
    if (typeof v === "string" || typeof v === "number") {
      out.push(String(v));
    } else if (typeof v === "object") {
      for (const [k, on] of Object.entries(v)) if (on) out.push(k);
    }
  }
  return out.join(" ");
}
